export function getIsActive({
  isLoaded,
  isMatchingPath,
  itemHash,
  isMatchingHash,
  isNoHash,
}: {
  isLoaded: boolean;
  isMatchingPath: boolean;
  itemHash: string;
  isMatchingHash: boolean;
  isNoHash: boolean;
}) {
  const isHomeHash = itemHash === 'home';
  const isNoItemHash = !itemHash;

  if (!isLoaded) {
    return isMatchingPath && (isNoItemHash || isHomeHash);
  }

  const isMatchingPathAndHash =
    isMatchingPath && (isMatchingHash || isHomeHash || isNoItemHash);
  const isHomePathWithoutHash = isHomeHash && isMatchingPath && !isNoHash;

  if (isMatchingPathAndHash || isHomePathWithoutHash) {
    return true;
  }

  return false;
}
